import { gql } from "@apollo/client";

export const GET_STORE = gql`
	query GetStore {
		shop {
			zipCode
		}
	}
`;
